import http from '@/assets/js/http';
import dkAxiosFile from '@/assets/js/fetch';

// 获取验证码
export const getIdentifyCode = (data) => {
  return http.post('/v1/app/SendCode', data)
}

// 登录
export const codeLogin = (data) => {
  return http.post('/v1/app/VerificationCodeLogin', data)
}

//微信扫码登录
export const WxCodeLogin = (data) =>{
  return http.post('/v1/app/WxCodeLogin', data)
}

//微信绑定账号
export const WxBindAccount = (data) =>{
  return http.post('/v1/app/WxBindAccount', data)
}
// 获取七牛信息
export const communal = () => {
  return http.get('/v1/app/Communal')
}

// 获取个人信息
export const userInfo = () => {
  return http.get('/v1/app/UserInfo')
}

//获取钱包余额
export const myWallet = function() {
	return http.get('/v1/app/Wallet');
}

// 上传图片
export const uploadImg = data => dkAxiosFile({
  url: 'https://upload-z2.qiniup.com',
  headers: {
    'content-type': 'multipart/form-data',
  },
  method: 'POST',
  data,
})


//获取验证码
export const getCaptchaImage = function() {
  return http.get('/v1/app/captcha');
}

